import { iconConfig } from './iconType'
import { CSSProperties } from 'react'
interface IconProps {
	variant: keyof typeof iconConfig
	className?: string
	style?: CSSProperties
}

export const Icon = ({ variant, className = '', style }: IconProps) => {
	return (
		<svg className={`${className}`} aria-label={iconConfig[variant].ariaLabel} style={style}>
			<use href={`assets/icons/default/sprite.svg#${iconConfig[variant].iconPath}`}></use>
		</svg>
	)
}
